export default __webpack_public_path__ + "static/media/sixteen.d0acaf24.jpeg";